import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { alertMessage } from "../../utils/AlertService";
import { REPORT_NAME, ACTION_TYPE } from "../constant/reportType";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import Loading from "../Loading";

import {
    useSaveMintingTransactionMutation,
    useUpdateMintingTransactionMutation,
    useGetMintingTransactionByIdMutation,
    useBulkUploadMintingTransactionMutation,
} from "../../redux-toolkit/services/mintingTransactionService";
import {
    useSaveCarbonInventoryMutation,
    useUpdateCarbonInventoryMutation,
    useGetCarbonInventoryByIdMutation,
    useBulkUploadCarbonInventoryMutation,
} from "../../redux-toolkit/services/carbonInventoryService";
import {
    useSaveCarbonSaleTransactionMutation,
    useUpdateCarbonSaleTransactionMutation,
    useGetCarbonSaleTransactionByIdMutation,
    useBulkUploadCarbonSaleTransactionMutation,
} from "../../redux-toolkit/services/carbonSaleTransactionService";
import {
    useSaveRetirementTransactionMutation,
    useUpdateRetirementTransactionMutation,
    useGetRetirementTransactionByIdMutation,
    useBulkUploadRetirementTransactionMutation,
} from "../../redux-toolkit/services/retirementTransactionService";

import { useFindAllEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";
import { useFindAllEntityTypeMasterMutation } from "../../redux-toolkit/services/entityTypeMasterService";
import { useFindAllAssetTypeMutation } from "../../redux-toolkit/services/assetTypeService";
import { useFindAllAssetsMutation } from "../../redux-toolkit/services/assetsService";
import { useFindAllOpportunityTypeMutation } from "../../redux-toolkit/services/opportunityTypeService";
import { useFindAllOpportunityApplicationMutation } from "../../redux-toolkit/services/opportunityApplicationService";
import { useFindAllProjectsMutation, useGetAllProjectsMutation } from "../../redux-toolkit/services/projectIntegrationService";

// Helper components mapping logic
const SelectField = ({ name, label, options, labelKey, handleDropdownChange, value }: any) => {
    const getLabel = (opt: any) => {
        const val = opt[labelKey] || opt.name || opt.id;
        if (typeof val === "object" && val !== null) {
            return val.name || val.code || val.projectName || val.id || JSON.stringify(val);
        }
        return val;
    };

    return (
        <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">{label}</label>
            <select className="form-select" name={name} value={value} onChange={handleDropdownChange}>
                <option value="">-- Select {label} --</option>
                {options?.map((opt: any) => (
                    <option key={opt.id} value={opt.id}>{String(getLabel(opt))}</option>
                ))}
            </select>
        </div>
    );
};

const ts = (d: any) => d ? new Date(d).toISOString().split('T')[0] : "";
const tsd = (d: any) => d ? new Date(d).toISOString().slice(0, 16) : "";

const CarbonTransactionData = (props: any) => {
    const localUserObj = getLocalStorageData("localUser");
    const [values, setValues] = useState<any>({});
    const [getByIdData, setGetByIdData] = useState<any>({});
    const [activeTab, setActiveTab] = useState("manual"); // "manual" or "bulk"
    const [bulkFile, setBulkFile] = useState<File | null>(null);

    // Lookups
    const [allProjectsList, setAllProjectsList] = useState<any[]>([]);
    const [allEntities, setAllEntities] = useState<any[]>([]);
    const [allEntityTypes, setAllEntityTypes] = useState<any[]>([]);
    const [allAssets, setAllAssets] = useState<any[]>([]);
    const [allAssetTypes, setAllAssetTypes] = useState<any[]>([]);
    const [allOppTypes, setAllOppTypes] = useState<any[]>([]);
    const [allOppApps, setAllOppApps] = useState<any[]>([]);

    const [findAllProjects, allProjectsRes] = useFindAllProjectsMutation();
    const [findAllEntity, findAllEntityRes] = useFindAllEntityMasterMutation();
    const [findAllEntityType, findAllEntityTypeRes] = useFindAllEntityTypeMasterMutation();
    const [findAllAssets, findAllAssetsRes] = useFindAllAssetsMutation();
    const [findAllAssetType, findAllAssetTypeRes] = useFindAllAssetTypeMutation();
    const [findAllOppType, findAllOppTypeRes] = useFindAllOpportunityTypeMutation();
    const [findAllOppApp, findAllOppAppRes] = useFindAllOpportunityApplicationMutation();

    // Mutations
    const [saveMintingTransaction, saveMintingTransactionRes] = useSaveMintingTransactionMutation();
    const [updateMintingTransaction, updateMintingTransactionRes] = useUpdateMintingTransactionMutation();
    const [getMintingTransactionById, mintingTransactionByIdRes] = useGetMintingTransactionByIdMutation();
    const [bulkUploadMintingTransaction, bulkUploadMintingTransactionRes] = useBulkUploadMintingTransactionMutation();

    const [saveCarbonInventory, saveCarbonInventoryRes] = useSaveCarbonInventoryMutation();
    const [updateCarbonInventory, updateCarbonInventoryRes] = useUpdateCarbonInventoryMutation();
    const [getCarbonInventoryById, carbonInventoryByIdRes] = useGetCarbonInventoryByIdMutation();
    const [bulkUploadCarbonInventory, bulkUploadCarbonInventoryRes] = useBulkUploadCarbonInventoryMutation();

    const [saveCarbonSale, saveCarbonSaleRes] = useSaveCarbonSaleTransactionMutation();
    const [updateCarbonSale, updateCarbonSaleRes] = useUpdateCarbonSaleTransactionMutation();
    const [getCarbonSaleById, carbonSaleByIdRes] = useGetCarbonSaleTransactionByIdMutation();
    const [bulkUploadCarbonSale, bulkUploadCarbonSaleRes] = useBulkUploadCarbonSaleTransactionMutation();

    const [saveRetirement, saveRetirementRes] = useSaveRetirementTransactionMutation();
    const [updateRetirement, updateRetirementRes] = useUpdateRetirementTransactionMutation();
    const [getRetirementById, retirementByIdRes] = useGetRetirementTransactionByIdMutation();
    const [bulkUploadRetirement, bulkUploadRetirementRes] = useBulkUploadRetirementTransactionMutation();

    useEffect(() => {
        if (props.show) {
            const token = localUserObj?.token;
            findAllProjects({ token });
            findAllEntity({ token });
            findAllEntityType({ token });
            findAllAssets({ token });
            findAllAssetType({ token });
            findAllOppType({ token });
            findAllOppApp({ token });

            if (props.actionType === ACTION_TYPE.UPDATE_ACTION && props.data?.id) {
                if (props.reportName === REPORT_NAME.MINTING_TRANSACTION) getMintingTransactionById({ token: localUserObj?.token, id: props.data.id });
                else if (props.reportName === REPORT_NAME.CARBON_INVENTORY) getCarbonInventoryById({ token: localUserObj?.token, id: props.data.id });
                else if (props.reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) getCarbonSaleById({ token: localUserObj?.token, id: props.data.id });
                else if (props.reportName === REPORT_NAME.RETIREMENT_TRANSACTION) getRetirementById({ token: localUserObj?.token, id: props.data.id });
            }
        }
    }, [props.show, props.reportName]);

    useEffect(() => { if (allProjectsRes.isSuccess) setAllProjectsList((allProjectsRes.data as any)?.data ?? (allProjectsRes.data as any) ?? []); }, [allProjectsRes.isSuccess]);
    useEffect(() => { if (findAllEntityRes.isSuccess) setAllEntities((findAllEntityRes.data as any)?.data ?? (findAllEntityRes.data as any) ?? []); }, [findAllEntityRes.isSuccess]);
    useEffect(() => { if (findAllEntityTypeRes.isSuccess) setAllEntityTypes((findAllEntityTypeRes.data as any)?.data ?? (findAllEntityTypeRes.data as any) ?? []); }, [findAllEntityTypeRes.isSuccess]);
    useEffect(() => { if (findAllAssetsRes.isSuccess) setAllAssets((findAllAssetsRes.data as any)?.data ?? (findAllAssetsRes.data as any) ?? []); }, [findAllAssetsRes.isSuccess]);
    useEffect(() => { if (findAllAssetTypeRes.isSuccess) setAllAssetTypes((findAllAssetTypeRes.data as any)?.data ?? (findAllAssetTypeRes.data as any) ?? []); }, [findAllAssetTypeRes.isSuccess]);
    useEffect(() => { if (findAllOppTypeRes.isSuccess) setAllOppTypes((findAllOppTypeRes.data as any)?.data ?? (findAllOppTypeRes.data as any) ?? []); }, [findAllOppTypeRes.isSuccess]);
    useEffect(() => { if (findAllOppAppRes.isSuccess) setAllOppApps((findAllOppAppRes.data as any)?.data ?? (findAllOppAppRes.data as any) ?? []); }, [findAllOppAppRes.isSuccess]);

    useEffect(() => { if (mintingTransactionByIdRes.isSuccess) setGetByIdData(mintingTransactionByIdRes.data || {}); }, [mintingTransactionByIdRes.isSuccess]);
    useEffect(() => { if (carbonInventoryByIdRes.isSuccess) setGetByIdData(carbonInventoryByIdRes.data || {}); }, [carbonInventoryByIdRes.isSuccess]);
    useEffect(() => { if (carbonSaleByIdRes.isSuccess) setGetByIdData(carbonSaleByIdRes.data || {}); }, [carbonSaleByIdRes.isSuccess]);
    useEffect(() => { if (retirementByIdRes.isSuccess) setGetByIdData(retirementByIdRes.data || {}); }, [retirementByIdRes.isSuccess]);

    // Save effects
    useEffect(() => {
        if (saveMintingTransactionRes.isSuccess) { alertMessage("Minting Transaction saved", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (saveMintingTransactionRes.isError) alertMessage("Error saving Minting Transaction", "error");
    }, [saveMintingTransactionRes.isSuccess, saveMintingTransactionRes.isError]);

    useEffect(() => {
        if (saveCarbonInventoryRes.isSuccess) { alertMessage("Carbon Inventory saved", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (saveCarbonInventoryRes.isError) alertMessage("Error saving Carbon Inventory", "error");
    }, [saveCarbonInventoryRes.isSuccess, saveCarbonInventoryRes.isError]);

    useEffect(() => {
        if (saveCarbonSaleRes.isSuccess) { alertMessage("Sale Transaction saved", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (saveCarbonSaleRes.isError) alertMessage("Error saving Sale Transaction", "error");
    }, [saveCarbonSaleRes.isSuccess, saveCarbonSaleRes.isError]);

    useEffect(() => {
        if (saveRetirementRes.isSuccess) { alertMessage("Retirement Transaction saved", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (saveRetirementRes.isError) alertMessage("Error saving Retirement Transaction", "error");
    }, [saveRetirementRes.isSuccess, saveRetirementRes.isError]);

    // Update effects
    useEffect(() => {
        if (updateMintingTransactionRes.isSuccess) { alertMessage("Minting Transaction updated", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (updateMintingTransactionRes.isError) alertMessage("Error updating Minting Transaction", "error");
    }, [updateMintingTransactionRes.isSuccess, updateMintingTransactionRes.isError]);

    useEffect(() => {
        if (updateCarbonInventoryRes.isSuccess) { alertMessage("Carbon Inventory updated", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (updateCarbonInventoryRes.isError) alertMessage("Error updating Carbon Inventory", "error");
    }, [updateCarbonInventoryRes.isSuccess, updateCarbonInventoryRes.isError]);

    useEffect(() => {
        if (updateCarbonSaleRes.isSuccess) { alertMessage("Sale Transaction updated", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (updateCarbonSaleRes.isError) alertMessage("Error updating Sale Transaction", "error");
    }, [updateCarbonSaleRes.isSuccess, updateCarbonSaleRes.isError]);

    useEffect(() => {
        if (updateRetirementRes.isSuccess) { alertMessage("Retirement Transaction updated", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (updateRetirementRes.isError) alertMessage("Error updating Retirement Transaction", "error");
    }, [updateRetirementRes.isSuccess, updateRetirementRes.isError]);

    // Bulk upload effects
    useEffect(() => {
        if (bulkUploadMintingTransactionRes.isSuccess) { alertMessage("Bulk upload successful", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (bulkUploadMintingTransactionRes.isError) alertMessage("Error during bulk upload", "error");
    }, [bulkUploadMintingTransactionRes.isSuccess, bulkUploadMintingTransactionRes.isError]);

    useEffect(() => {
        if (bulkUploadCarbonInventoryRes.isSuccess) { alertMessage("Bulk upload successful", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (bulkUploadCarbonInventoryRes.isError) alertMessage("Error during bulk upload", "error");
    }, [bulkUploadCarbonInventoryRes.isSuccess, bulkUploadCarbonInventoryRes.isError]);

    useEffect(() => {
        if (bulkUploadCarbonSaleRes.isSuccess) { alertMessage("Bulk upload successful", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (bulkUploadCarbonSaleRes.isError) alertMessage("Error during bulk upload", "error");
    }, [bulkUploadCarbonSaleRes.isSuccess, bulkUploadCarbonSaleRes.isError]);

    useEffect(() => {
        if (bulkUploadRetirementRes.isSuccess) { alertMessage("Bulk upload successful", "success"); props.setCall(Date.now().toString()); handleClose(); }
        else if (bulkUploadRetirementRes.isError) alertMessage("Error during bulk upload", "error");
    }, [bulkUploadRetirementRes.isSuccess, bulkUploadRetirementRes.isError]);

    const handleClose = () => props.setShow(false);

    const handleBulkUpload = () => {
        if (!bulkFile) { alertMessage("Please select an XLSX file first.", "error"); return; }
        const formData = new FormData();
        formData.append("file", bulkFile);
        if (props.reportName === REPORT_NAME.MINTING_TRANSACTION) bulkUploadMintingTransaction({ token: localUserObj?.token, payload: formData });
        else if (props.reportName === REPORT_NAME.CARBON_INVENTORY) bulkUploadCarbonInventory({ token: localUserObj?.token, payload: formData });
        else if (props.reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) bulkUploadCarbonSale({ token: localUserObj?.token, payload: formData });
        else if (props.reportName === REPORT_NAME.RETIREMENT_TRANSACTION) bulkUploadRetirement({ token: localUserObj?.token, payload: formData });
    };

    const submitHandler = () => {
        const isAdd = props.actionType === ACTION_TYPE.ADD_ACTION;
        if (props.reportName === REPORT_NAME.MINTING_TRANSACTION) {
            const payload = {
                ...(isAdd ? {} : { id: props.data?.id }),
                entityTypeId: values.entityTypeId ? Number(values.entityTypeId) : null,
                entityId: values.entityId ? Number(values.entityId) : null,
                assetTypeId: values.assetTypeId ? Number(values.assetTypeId) : null,
                assetId: values.assetId ? Number(values.assetId) : null,
                opportunityTypeId: values.opportunityTypeId ? Number(values.opportunityTypeId) : null,
                opportunityApplicationId: values.opportunityApplicationId ? Number(values.opportunityApplicationId) : null,
                vintage: values.vintage || null,
                mintDate: values.mintDate || null,
                quantity: values.quantity ? parseFloat(values.quantity) : null,
                registryRef: values.registryRef || null,
                planStart: values.planStart || null,
                planEnd: values.planEnd || null,
                actualStart: values.actualStart || null,
                actualEnd: values.actualEnd || null,
                remarks: values.remarks || null,
                status: isAdd ? true : props.data?.status,
            };
            if (isAdd) saveMintingTransaction({ token: localUserObj?.token, payload });
            else updateMintingTransaction({ token: localUserObj?.token, payload });
        } else if (props.reportName === REPORT_NAME.CARBON_INVENTORY) {
            const payload = {
                ...(isAdd ? {} : { id: props.data?.id }),
                entityTypeId: values.entityTypeId ? Number(values.entityTypeId) : null,
                entityId: values.entityId ? Number(values.entityId) : null,
                assetTypeId: values.assetTypeId ? Number(values.assetTypeId) : null,
                assetId: values.assetId ? Number(values.assetId) : null,
                opportunityTypeId: values.opportunityTypeId ? Number(values.opportunityTypeId) : null,
                opportunityApplicationId: values.opportunityApplicationId ? Number(values.opportunityApplicationId) : null,
                projectId: values.projectId ? Number(values.projectId) : null,
                vintage: values.vintage || null,
                quantity: values.quantity ? parseFloat(values.quantity) : null,
                lastUpdatedDate: values.lastUpdatedDate || null,
                carbonInventoryStatus: values.carbonInventoryStatus || "Available",
                planStart: values.planStart || null,
                planEnd: values.planEnd || null,
                actualStart: values.actualStart || null,
                actualEnd: values.actualEnd || null,
                remarks: values.remarks || null,
                status: isAdd ? true : props.data?.status,
            };
            if (isAdd) saveCarbonInventory({ token: localUserObj?.token, payload });
            else updateCarbonInventory({ token: localUserObj?.token, payload });
        } else if (props.reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) {
            const payload = {
                ...(isAdd ? {} : { id: props.data?.id }),
                entityTypeId: values.entityTypeId ? Number(values.entityTypeId) : null,
                entityId: values.entityId ? Number(values.entityId) : null,
                assetTypeId: values.assetTypeId ? Number(values.assetTypeId) : null,
                assetId: values.assetId ? Number(values.assetId) : null,
                opportunityTypeId: values.opportunityTypeId ? Number(values.opportunityTypeId) : null,
                opportunityApplicationId: values.opportunityApplicationId ? Number(values.opportunityApplicationId) : null,
                buyer: values.buyer || null,
                saleDate: values.date || null,
                quantity: values.qty ? parseFloat(values.qty) : null,
                price: values.price ? parseFloat(values.price) : null,
                totalValue: values.totalValue ? parseFloat(values.totalValue) : null,
                planStart: values.planStart || null,
                planEnd: values.planEnd || null,
                actualStart: values.actualStart || null,
                actualEnd: values.actualEnd || null,
                remarks: values.remarks || null,
                status: isAdd ? true : props.data?.status,
            };
            if (isAdd) saveCarbonSale({ token: localUserObj?.token, payload });
            else updateCarbonSale({ token: localUserObj?.token, payload });
        } else if (props.reportName === REPORT_NAME.RETIREMENT_TRANSACTION) {
            const payload = {
                ...(isAdd ? {} : { id: props.data?.id }),
                entityTypeId: values.entityTypeId ? Number(values.entityTypeId) : null,
                entityId: values.entityId ? Number(values.entityId) : null,
                assetTypeId: values.assetTypeId ? Number(values.assetTypeId) : null,
                assetId: values.assetId ? Number(values.assetId) : null,
                opportunityTypeId: values.opportunityTypeId ? Number(values.opportunityTypeId) : null,
                opportunityApplicationId: values.opportunityApplicationId ? Number(values.opportunityApplicationId) : null,
                retirementDate: values.retirementDate || null,
                quantity: values.quantity ? parseFloat(values.quantity) : null,
                reason: values.reason || null,
                registryProof: values.registryProof || null,
                planStart: values.planStart || null,
                planEnd: values.planEnd || null,
                actualStart: values.actualStart || null,
                actualEnd: values.actualEnd || null,
                remarks: values.remarks || null,
                status: isAdd ? true : props.data?.status,
            };
            if (isAdd) saveRetirement({ token: localUserObj?.token, payload });
            else updateRetirement({ token: localUserObj?.token, payload });
        }
    };

    const getInitialValues = () => {
        const d = props.actionType === ACTION_TYPE.UPDATE_ACTION ? getByIdData : null;
        if (props.reportName === REPORT_NAME.MINTING_TRANSACTION) {
            return {
                entityTypeId: d?.entityType?.id || "",
                entityId: d?.entity?.id || "",
                assetTypeId: d?.assetType?.id || "",
                assetId: d?.assets?.id || "",
                opportunityTypeId: d?.opportunityType?.id || "",
                opportunityApplicationId: d?.opportunityApplication?.id || "",
                vintage: tsd(d?.vintage),
                mintDate: ts(d?.mintDate),
                quantity: d?.quantity || "",
                registryRef: d?.registryRef || "",
                planStart: ts(d?.planStart),
                planEnd: ts(d?.planEnd),
                actualStart: ts(d?.actualStart),
                actualEnd: ts(d?.actualEnd),
                remarks: d?.remarks || "",
            };
        } else if (props.reportName === REPORT_NAME.CARBON_INVENTORY) {
            return {
                entityTypeId: d?.entityType?.id || "",
                entityId: d?.entity?.id || "",
                assetTypeId: d?.assetType?.id || "",
                assetId: d?.assets?.id || "",
                opportunityTypeId: d?.opportunityType?.id || "",
                opportunityApplicationId: d?.opportunityApplication?.id || "",
                projectId: d?.projectId || d?.project?.id || "",
                vintage: tsd(d?.vintage),
                quantity: d?.quantity || "",
                lastUpdatedDate: ts(d?.lastUpdatedDate || d?.lastUpdated),
                carbonInventoryStatus: d?.carbonInventoryStatus || d?.status || "",
                planStart: ts(d?.planStart),
                planEnd: ts(d?.planEnd),
                actualStart: ts(d?.actualStart),
                actualEnd: ts(d?.actualEnd),
                remarks: d?.remarks || "",
            };
        } else if (props.reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) {
            return {
                entityTypeId: d?.entityType?.id || "",
                entityId: d?.entity?.id || "",
                assetTypeId: d?.assetType?.id || "",
                assetId: d?.assets?.id || "",
                opportunityTypeId: d?.opportunityType?.id || "",
                opportunityApplicationId: d?.opportunityApplication?.id || "",
                buyer: d?.buyer || "",
                date: ts(d?.saleDate || d?.date),
                qty: d?.quantity || d?.qty || "",
                price: d?.price || "",
                totalValue: d?.totalValue || "",
                planStart: ts(d?.planStart),
                planEnd: ts(d?.planEnd),
                actualStart: ts(d?.actualStart),
                actualEnd: ts(d?.actualEnd),
                remarks: d?.remarks || "",
            };
        } else if (props.reportName === REPORT_NAME.RETIREMENT_TRANSACTION) {
            return {
                entityTypeId: d?.entityType?.id || "",
                entityId: d?.entity?.id || "",
                assetTypeId: d?.assetType?.id || "",
                assetId: d?.assets?.id || "",
                opportunityTypeId: d?.opportunityType?.id || "",
                opportunityApplicationId: d?.opportunityApplication?.id || "",
                retirementDate: ts(d?.retirementDate),
                quantity: d?.quantity || "",
                reason: d?.reason || "",
                registryProof: d?.registryProof || "",
                planStart: ts(d?.planStart),
                planEnd: ts(d?.planEnd),
                actualStart: ts(d?.actualStart),
                actualEnd: ts(d?.actualEnd),
                remarks: d?.remarks || "",
            };
        }
        return {};
    };

    useEffect(() => {
        if ((props.actionType === ACTION_TYPE.UPDATE_ACTION && Object.keys(getByIdData).length > 0) || props.actionType === ACTION_TYPE.ADD_ACTION) {
            setValues(getInitialValues());
        }
    }, [props.actionType, getByIdData, props.reportName]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target as any;
        const checked = (e.target as any).checked;
        setValues((prev: any) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    };

    const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { name, value } = e.target;
        let updatedValues = { ...values, [name]: value };

        // Auto-selection logic
        if (name === "entityId" && value) {
            const selected = allEntities.find(x => x.id == value);
            if (selected?.entityType?.id) updatedValues.entityTypeId = String(selected.entityType.id);
        } else if (name === "assetId" && value) {
            const selected = allAssets.find(x => x.id == value);
            if (selected?.assetType?.id) updatedValues.assetTypeId = String(selected.assetType.id);
        } else if (name === "opportunityApplicationId" && value) {
            const selected = allOppApps.find(x => x.id == value);
            if (selected?.opportunityType?.id) updatedValues.opportunityTypeId = String(selected.opportunityType.id);
        }

        setValues(updatedValues);
    };

    const filteredEntities = allEntities.filter((e: any) => !values.entityTypeId || e.entityType?.id === Number(values.entityTypeId));
    // Asset filters: if an asset type is selected, show only assets of that type (just like entityType filters entities)
    const filteredAssets = allAssets.filter((a: any) => !values.assetTypeId || a.assetType?.id === Number(values.assetTypeId) || a.assetTypeId === Number(values.assetTypeId));
    
    const filteredOppApps = allOppApps.filter((o: any) => !values.opportunityTypeId || o.opportunityType?.id === Number(values.opportunityTypeId));

    const renderSpecificFields = () => {
        if (props.reportName === REPORT_NAME.MINTING_TRANSACTION) {
            return (
                <>
                    <SelectField name="entityId" label="Entity" options={filteredEntities} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityId} />
                    <SelectField name="entityTypeId" label="Entity Type" options={allEntityTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityTypeId} />

                    <SelectField name="assetId" label="Asset" options={filteredAssets} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetId} />

                    <SelectField name="assetTypeId" label="Asset Type" options={allAssetTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetTypeId} />

                    <SelectField name="opportunityTypeId" label="Opportunity Type" options={allOppTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.opportunityTypeId} />
                    <SelectField name="opportunityApplicationId" label="Opportunity Application" options={filteredOppApps} labelKey="projectName" handleDropdownChange={handleDropdownChange} value={values.opportunityApplicationId} />

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Vintage</label>
                        <input type="datetime-local" className="form-control" name="vintage" value={values.vintage} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Mint Date</label>
                        <input type="date" className="form-control" name="mintDate" value={values.mintDate} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Quantity</label>
                        <input type="number" step="any" className="form-control" name="quantity" value={values.quantity} onChange={handleChange} placeholder="Enter Quantity" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Registry Ref</label>
                        <input type="text" className="form-control" name="registryRef" value={values.registryRef} onChange={handleChange} placeholder="Enter Registry Ref" />
                    </div>

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan Start</label>
                        <input type="date" className="form-control" name="planStart" value={values.planStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan End</label>
                        <input type="date" className="form-control" name="planEnd" value={values.planEnd} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual Start</label>
                        <input type="date" className="form-control" name="actualStart" value={values.actualStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual End</label>
                        <input type="date" className="form-control" name="actualEnd" value={values.actualEnd} onChange={handleChange} />
                    </div>

                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={values.remarks} onChange={handleChange} rows={3} placeholder="Enter Remarks" />
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.CARBON_INVENTORY) {
            return (
                <>
                    <SelectField name="entityId" label="Entity" options={filteredEntities} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityId} />
                    <SelectField name="entityTypeId" label="Entity Type" options={allEntityTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityTypeId} />

                    <SelectField name="assetId" label="Asset" options={filteredAssets} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetId} />

                    <SelectField name="assetTypeId" label="Asset Type" options={allAssetTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetTypeId} />

                    <SelectField name="opportunityTypeId" label="Opportunity Type" options={allOppTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.opportunityTypeId} />
                    <SelectField name="opportunityApplicationId" label="Opportunity Application" options={filteredOppApps} labelKey="projectName" handleDropdownChange={handleDropdownChange} value={values.opportunityApplicationId} />

                    <SelectField name="projectId" label="Project" options={allProjectsList} labelKey="projectName" handleDropdownChange={handleDropdownChange} value={values.projectId} />

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Vintage</label>
                        <input type="datetime-local" className="form-control" name="vintage" value={values.vintage} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Quantity</label>
                        <input type="number" step="any" className="form-control" name="quantity" value={values.quantity} onChange={handleChange} placeholder="Enter Quantity" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Last Updated</label>
                        <input type="date" className="form-control" name="lastUpdatedDate" value={values.lastUpdatedDate} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Status</label>
                        <select className="form-select" name="carbonInventoryStatus" value={values.carbonInventoryStatus} onChange={handleChange}>
                            <option value="">-- Select Status --</option>
                            <option value="Available">Available</option>
                            <option value="Sold">Sold</option>
                            <option value="Retired">Retired</option>
                        </select>
                    </div>

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan Start</label>
                        <input type="date" className="form-control" name="planStart" value={values.planStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan End</label>
                        <input type="date" className="form-control" name="planEnd" value={values.planEnd} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual Start</label>
                        <input type="date" className="form-control" name="actualStart" value={values.actualStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual End</label>
                        <input type="date" className="form-control" name="actualEnd" value={values.actualEnd} onChange={handleChange} />
                    </div>

                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={values.remarks} onChange={handleChange} rows={3} placeholder="Enter Remarks" />
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) {
            return (
                <>
                    <SelectField name="entityTypeId" label="Entity Type" options={allEntityTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityTypeId} />
                    <SelectField name="entityId" label="Entity" options={filteredEntities} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityId} />

                    <SelectField name="assetId" label="Asset" options={filteredAssets} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetId} />

                    <SelectField name="assetTypeId" label="Asset Type" options={allAssetTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetTypeId} />

                    <SelectField name="opportunityTypeId" label="Opportunity Type" options={allOppTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.opportunityTypeId} />
                    <SelectField name="opportunityApplicationId" label="Opportunity Application" options={filteredOppApps} labelKey="projectName" handleDropdownChange={handleDropdownChange} value={values.opportunityApplicationId} />

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Buyer</label>
                        <input type="text" className="form-control" name="buyer" value={values.buyer} onChange={handleChange} placeholder="Enter Buyer" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Date</label>
                        <input type="date" className="form-control" name="date" value={values.date} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Qty</label>
                        <input type="number" step="any" className="form-control" name="qty" value={values.qty} onChange={handleChange} placeholder="Enter Qty" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Price</label>
                        <input type="number" step="any" className="form-control" name="price" value={values.price} onChange={handleChange} placeholder="Enter Price" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Total Value</label>
                        <input type="number" step="any" className="form-control" name="totalValue" value={values.totalValue} onChange={handleChange} placeholder="Enter Total Value" />
                    </div>

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan Start</label>
                        <input type="date" className="form-control" name="planStart" value={values.planStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan End</label>
                        <input type="date" className="form-control" name="planEnd" value={values.planEnd} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual Start</label>
                        <input type="date" className="form-control" name="actualStart" value={values.actualStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual End</label>
                        <input type="date" className="form-control" name="actualEnd" value={values.actualEnd} onChange={handleChange} />
                    </div>

                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={values.remarks} onChange={handleChange} rows={3} placeholder="Enter Remarks" />
                    </div>
                </>
            );
        } else if (props.reportName === REPORT_NAME.RETIREMENT_TRANSACTION) {
            return (
                <>
                    <SelectField name="entityTypeId" label="Entity Type" options={allEntityTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityTypeId} />
                    <SelectField name="entityId" label="Entity" options={filteredEntities} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.entityId} />

                    <SelectField name="assetId" label="Asset" options={filteredAssets} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetId} />

                    <SelectField name="assetTypeId" label="Asset Type" options={allAssetTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.assetTypeId} />

                    <SelectField name="opportunityTypeId" label="Opportunity Type" options={allOppTypes} labelKey="name" handleDropdownChange={handleDropdownChange} value={values.opportunityTypeId} />
                    <SelectField name="opportunityApplicationId" label="Opportunity Application" options={filteredOppApps} labelKey="projectName" handleDropdownChange={handleDropdownChange} value={values.opportunityApplicationId} />

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Retirement Date</label>
                        <input type="date" className="form-control" name="retirementDate" value={values.retirementDate} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Quantity</label>
                        <input type="number" step="any" className="form-control" name="quantity" value={values.quantity} onChange={handleChange} placeholder="Enter Quantity" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Reason</label>
                        <input type="text" className="form-control" name="reason" value={values.reason} onChange={handleChange} placeholder="Enter Reason" />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Registry Proof</label>
                        <input type="text" className="form-control" name="registryProof" value={values.registryProof} onChange={handleChange} placeholder="Enter Registry Proof" />
                    </div>

                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan Start</label>
                        <input type="date" className="form-control" name="planStart" value={values.planStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Plan End</label>
                        <input type="date" className="form-control" name="planEnd" value={values.planEnd} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual Start</label>
                        <input type="date" className="form-control" name="actualStart" value={values.actualStart} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Actual End</label>
                        <input type="date" className="form-control" name="actualEnd" value={values.actualEnd} onChange={handleChange} />
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={values.remarks} onChange={handleChange} rows={3} placeholder="Enter Remarks" />
                    </div>
                </>
            );
        }
        return null;
    };

    const isLoading =
        saveMintingTransactionRes.isLoading || updateMintingTransactionRes.isLoading ||
        bulkUploadMintingTransactionRes.isLoading ||
        saveCarbonInventoryRes.isLoading || updateCarbonInventoryRes.isLoading ||
        bulkUploadCarbonInventoryRes.isLoading ||
        saveCarbonSaleRes.isLoading || updateCarbonSaleRes.isLoading ||
        bulkUploadCarbonSaleRes.isLoading ||
        saveRetirementRes.isLoading || updateRetirementRes.isLoading ||
        bulkUploadRetirementRes.isLoading;

    return (
        <Modal show={props.show} onHide={handleClose} size="lg" centered scrollable>
            <Modal.Header closeButton className="bg-cm-light-primary1 border-0">
                <Modal.Title className="text-accent fw-bold">
                    {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"} {props.reportName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && <Loading />}

                {props.actionType === ACTION_TYPE.ADD_ACTION && (
                    <div className="d-flex mb-3 border-bottom pb-2">
                        <button type="button" className={`btn btn-sm me-2 ${activeTab === "manual" ? "bg-accent text-white" : "btn-outline-secondary"}`} onClick={() => setActiveTab("manual")}>
                            Manual Entry
                        </button>
                        <button type="button" className={`btn btn-sm ${activeTab === "bulk" ? "bg-accent text-white" : "btn-outline-secondary"}`} onClick={() => setActiveTab("bulk")}>
                            Bulk Upload
                        </button>
                    </div>
                )}

                {activeTab === "manual" ? (
                    <div className="row">
                        {renderSpecificFields()}
                    </div>
                ) : (
                    <div className="row">
                        <div className="col-xs-12 mb-3">
                            <label className="form-label fw-semibold">Select XLSX File for {props.reportName}</label>
                            <input
                                type="file"
                                className="form-control"
                                accept=".xlsx"
                                onChange={(e) => setBulkFile(e.target.files ? e.target.files[0] : null)}
                            />
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="border-0">
                <button className="btn btn-outline-secondary fw-semibold font-10 px-4" onClick={handleClose}>
                    Close
                </button>
                {activeTab === "manual" ? (
                    <button className="btn bg-accent text-white fw-semibold font-10 px-4" onClick={submitHandler}>
                        Submit
                    </button>
                ) : (
                    <button className="btn bg-accent text-white fw-semibold font-10 px-4" onClick={handleBulkUpload}>
                        Upload
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default CarbonTransactionData;
